import { Loader } from '@src/components';
import { useAccount } from '@src/contexts';
import { useBusinessCheckContext } from '@src/contexts/business-check-context';
import { Path } from '@src/navigations/routes';
import React, { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PlainLayout = () => {
  const { resolvedPath } = useBusinessCheckContext();
  const { isLoggedIn, isWhiteLabelBusiness, businessVariant } = useAccount();

  const { pathname } = useLocation();

  const isClientPages = useMemo(() => {
    if (isWhiteLabelBusiness) return pathname.includes('/white-label/');
    if (businessVariant === 'receiver') return pathname.includes('/receiver/');
    if (businessVariant === 'sender') return pathname.includes('/sender/');
  }, [isWhiteLabelBusiness, pathname, businessVariant]);

  if (!isLoggedIn) {
    return <Navigate to={Path.Login} replace />;
  }

  if (resolvedPath && resolvedPath === 'loading') {
    if (resolvedPath === 'loading') return <Loader />;
  }

  if (!isClientPages && !!resolvedPath) {
    return <Navigate to={resolvedPath} replace />;
  }

  return <Outlet />;
};

export default PlainLayout;
